var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.white { fill: #FFFFFF; }\n\t.black { fill: #171717; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M256,2.6C116,2.6,2.6,116,2.6,256c0,126.5,92.7,231.3,213.8,250.4c12.9,2,26.1,3.1,39.6,3.1 c13.5,0,26.7-1.1,39.6-3.1c121.2-19,213.8-123.9,213.8-250.4C509.4,116,396,2.6,256,2.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "black",
    d: "M509.4,256C509.4,116,396,2.6,256,2.6S2.6,116,2.6,256c0,126.5,92.7,231.3,213.8,250.4V329.3h-64.3V256h64.3v-55.8 c0-63.5,37.8-98.6,95.7-98.6c27.7,0,56.7,5,56.7,5v62.4h-32c-31.5,0-41.3,19.5-41.3,39.6V256h70.3l-11.2,73.3h-59.1v177.1 C416.8,487.3,509.4,382.5,509.4,256z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.bf94574e.svg";
export { ForwardRef as ReactComponent };